import type { LscCommissionerDigest, LscCommissionerDigestSyncRunSample } from './types';

export const NO_VOD_SYNC_RUN_YET = 'No sync has been run yet.';

function isSuccessfulApplyRun(run?: LscCommissionerDigestSyncRunSample | null): boolean {
  if (!run || run.dry_run) {
    return false;
  }
  const status = String(run.status || '').trim().toLowerCase();
  return status === 'completed';
}

/** Latest completed non-preview apply/manual VOD sync timestamp from digest. */
export function lastSuccessfulVodSyncCompletedAt(
  digest: LscCommissionerDigest | null | undefined
): string | null {
  const runs = [
    digest?.automation?.latest_apply_run,
    digest?.automation?.latest_manual_run,
  ];
  let latest: string | null = null;
  for (const run of runs) {
    if (!isSuccessfulApplyRun(run)) {
      continue;
    }
    const at = run?.completed_at || run?.started_at || null;
    if (at && (!latest || at > latest)) {
      latest = at;
    }
  }
  return latest;
}

export function formatVodSyncLastRunLabel(iso: string | null): string {
  if (!iso) {
    return NO_VOD_SYNC_RUN_YET;
  }
  const parsed = Date.parse(iso);
  if (Number.isNaN(parsed)) {
    return NO_VOD_SYNC_RUN_YET;
  }
  return `Last successful sync: ${new Date(parsed).toLocaleString()}`;
}
